import { render, staticRenderFns } from "./MenuCatalog.vue?vue&type=template&id=7224a6fc&scoped=true&"
import script from "./MenuCatalog.vue?vue&type=script&lang=js&"
export * from "./MenuCatalog.vue?vue&type=script&lang=js&"
import style0 from "./MenuCatalog.vue?vue&type=style&index=0&id=7224a6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224a6fc",
  null
  
)

export default component.exports